import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from '../../../components/LoadingScreen';

const CreditCardOfferLearnMore = loadable(
  () => import('./CreditCardOfferLearnMore'),
  {
    fallback: <LoadingScreen />,
  },
);

export default CreditCardOfferLearnMore;
